import * as S from './styles'

export const IconCircle = ({ icon: Icon, template }: IconCircleProps) => (
  <S.Container className="wrapperIconCircle" template={template}>
    <Icon />
  </S.Container>
)
